<template>
    <div>
      <div style="word-break: auto-phrase; font-weight: 400; line-height: 1.6;">
        Sau khi hủy hợp đồng, hệ thống sẽ dừng các quy trình nhắc nhở thanh toán của khách hàng, bạn có chắc chắn muốn hủy hợp đồng vay của khách hàng?
      </div>
      <div class=" mt-4">
        <label for="">Nhập lý do hủy hợp đồng <span class="text-danger"> *</span></label>

        <el-input
            style="word-break: auto-phrase;"
            type="textarea"
            :rows="2"
            placeholder="Vui lòng nhập lý do hủy hợp đồng"
            maxlength="200"
            show-word-limit
            v-model="reason_cancel">
        </el-input>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <el-button style="background-color: #CACACA" @click="$emit('close')" size="mini" class="rounded">Hủy bỏ</el-button>
        <el-button style="background-color: #5D04B0" @click="cancelContract()" class="text-white rounded" size="mini">Xác nhận</el-button>
      </div>
    </div>
</template>

<script>

import {CANCEL_CONTRACT_CITIME} from "../../../../core/services/store/customer/customer-crm.module";

export default {
  name: "cancel-contact",
  components: {
    result: '',
  },
  data() {
    return {
      reason_cancel: '',
    }
  },

  mounted() {

  },

  methods: {
    cancelContract() {
      const payload = {
        id: this.$route.params.id,
        reason: this.reason_cancel,
      };

      this.$store
          .dispatch(CANCEL_CONTRACT_CITIME, payload)
          .then((res) => {
            if (!res?.error) {
              this.$notify({
                title: "Success",
                message: "Hủy hợp đồng thành công!",
                type: "success",
              });
              this.$router.push({ name: "citime-contract" });
            }
          })
          .catch(() => {
            this.$notify({
              title: "Error",
              message: "Hủy hợp đồng thất bại!",
              type: "error",
            });
          });
    }
  }
}
</script>
